import React from 'react'
import { styles } from './styles'
import { makeStyles } from '@material-ui/styles'

export const PasswordModal = ({
  onClose,
  handleSendEmail,
  countdown,
  emailSent,
  isPasswordCreated,
}) => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  return (
    <div className={classes.modalStyles} onClick={onClose}>
      <div className={classes.contentStyles} onClick={e => e.stopPropagation()}>
        <h2>
          {emailSent ? 'Now, check your email' : 'Get reset link in your email'}
        </h2>
        <p>
          {emailSent
            ? 'We’ve sent a link to your email. Use it to reset your password.'
            : isPasswordCreated
            ? 'To update your password, we’ll send a reset link to your email.'
            : 'To create your password, we’ll send a reset link to your email.'}
        </p>
        <div className={classes.buttonsContainer}>
          <button onClick={onClose} className={classes.cancelButton}>
            Cancel
          </button>
          <button
            onClick={handleSendEmail}
            disabled={emailSent}
            className={
              emailSent
                ? classes.sendEmailButtonDisabled
                : classes.sendEmailButton
            }
          >
            {emailSent ? `Resend email (${countdown}s)` : 'Send email'}
          </button>
        </div>
      </div>
    </div>
  )
}
